import { AuthAction } from './authActions'
import * as authConstants from './authConstants'
import { AFTER_REHYDRATE } from '../rehydrate/rehydrateConstants'
import { RehydrateAction } from '../rehydrate/rehydrateActions'

/* ------------- State ------------- */
type AuthStateType = typeof initialState
export interface AuthState extends AuthStateType {}

export const initialState = {
  accessToken: undefined as string | undefined,
  logInPending: false,
  logInError: undefined as string | undefined,
}

/* ------------- Reducers ------------- */
export default (state: AuthState = initialState, action: AuthAction | RehydrateAction): AuthState => {
  switch (action.type) {
    case authConstants.LOG_IN_REQUEST:
      return { ...state, logInPending: true, logInError: undefined }
    case authConstants.LOG_IN_SUCCESS:
      return { ...state, accessToken: action.accessToken, logInPending: false, logInError: undefined }
    case authConstants.LOG_IN_ERROR:
      return { ...state, logInPending: false, logInError: action.error }
    case authConstants.CLEAR_LOG_IN_ERROR:
      return { ...state, logInError: undefined }
    case authConstants.LOG_OUT:
      return { ...initialState }
    case AFTER_REHYDRATE:
      return { ...state, logInPending: false, logInError: undefined }
    default:
      return state
  }
}
